import React from 'react';
import { Grid, Button, useTheme } from '@mui/material';

const ActionButtons = ({
  applyFiltersClick,
  handleClearFilters,
  buttonHeight = 50,
  buttonMaxWidth = 300,
}) => {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={applyFiltersClick}
          fullWidth
          sx={{
            maxWidth: buttonMaxWidth,
            height: buttonHeight,
            fontSize: 18,
            fontWeight: 600,
            width: '100%',
            minWidth: '100%',
            color: theme?.tertiary || '#000',
            bgcolor: '#FFFFFF',
            border: `2px solid ${theme?.tertiary || '#000'}`,
            borderRadius: '8px',
            '&:hover': {
              bgcolor: '#d5d5d5',
              borderColor: theme?.tertiary || '#000',
            },
          }}
        >
          Aplicar filtros
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={handleClearFilters}
          fullWidth
          sx={{
            maxWidth: buttonMaxWidth,
            height: buttonHeight,
            fontSize: 18,
            fontWeight: 600,
            width: '100%',
            minWidth: '100%',
            color: theme?.tertiary || '#000',
            backgroundColor: '#FFFFFF',
            border: `2px solid ${theme?.tertiary || '#000'}`,
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#d5d5d5',
              borderColor: theme?.tertiary || '#000',
            },
          }}
        >
          Limpiar filtros
        </Button>
      </Grid>
    </>
  );
};

export default ActionButtons;
